import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { RestrictedAccess } from '../components';
import { UserRole } from '../types/user';
import { useAuthStore } from './useAuthStore';

interface RequireRoleProps {
  children: ReactNode;
  allowedRoles: UserRole[];
  noAccessMessage?: string;
  noAccessSubTitle?: string;
  backHome?: boolean;
  homePath?: string;
  onBackHomeClick?: () => void;
  redirectTo?: string;
}

export const RequireRole: React.FC<RequireRoleProps> = ({
  children,
  allowedRoles,
  noAccessMessage,
  noAccessSubTitle,
  backHome,
  homePath,
  onBackHomeClick,
  redirectTo,
}) => {
  const { user, isAuthenticated } = useAuthStore();

  if (!isAuthenticated || !user) {
    return null;
  }

  const hasRequiredRole = allowedRoles.some((role) => user.roles.includes(role));

  if (!hasRequiredRole) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    return (
      <RestrictedAccess
        message={noAccessMessage}
        subTitle={noAccessSubTitle}
        backHome={backHome}
        homePath={homePath}
        onBackHomeClick={onBackHomeClick}
      />
    );
  }

  return <>{children}</>;
};
